export default __webpack_public_path__ + "static/media/chibi-asta.fb9a0dee.png";